// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_modules_accordions_js") return "./js/chunks/dd10e48ab9ad1e91be62.js";
	if (chunkId === "assets_js_modules_dialog_js") return "./js/chunks/55c3146931a56c235b5d.js";
	if (chunkId === "assets_js_modules_header_js") return "./js/chunks/bec2285faef386c8f898.js";
	if (chunkId === "assets_js_modules_projects_js") return "./js/chunks/ecca213b1d3c4d096aff.js";
	if (chunkId === "assets_js_modules_stage_js") return "./js/chunks/323ca880354251c9bfd7.js";
	// return url for filenames based on template
	return undefined;
};